import React from "react"
import { Link } from "gatsby"
import { Helmet } from 'react-helmet'

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"

import TitleHome from "../components/titleHome"
import Team from "../components/team"
import Footer from "../components/footer"

import "../styles/main.css"
import "../utils/animateTitle.js"


const IndexPage = () => ( 
    <div className='container'>
        <Helmet title='Twaddle' />
        <TitleHome />
        <Team />
        <Footer />
    </div>
)

export default IndexPage
